<style scoped></style>
<template>
  <portal-box>
    <template slot="titulo">
      <h1 class="title is-4">Meta x Faturado</h1>
      <h3 class="subtitle is-6">Demonstrativo em {{ dia | moment("ddd, DD MMM  YYYY HH:mm") }}.</h3>
    </template>

    <!--<button slot="menu" class="button is-light" :class="{'is-loading': loading}" @click="consultar">-->
      <!--<b-icon icon="refresh" />-->
    <!--</button>-->


    <portal-loading-small :loading="loading" class="p-h-xl" />

    <template v-if="!loading">

      <section class="animated fadeIn">
        <grafico-barra :chart-data="dadosMetas" :height="300" :width="830"/>
      </section>

    </template>

  </portal-box>
</template>
<script>
  import GraficoBarra from '../graficos/GraficoBarra'

  export default {
    components: {GraficoBarra},
    created () {
      this.consultar()
    },
    data () {
      return {
        loading: false,
        dia: new Date(),
        meta: null,
        dadosMetas: null
      }
    },
    methods: {
      consultar () {
        this.loading = true
        this.dia = new Date()
        let url = this.$store.state.parametros.EMPRESA_NOME === 'FERMOPLAST' ? this.$URL.METAS.CARREGAR_META : this.$URL.METAS.MES_CORRENTE
        this.$http.get(url, this.$header()).then(res => {
          this.meta = res.body
          this.loading = false
          this.buildMetas()
        }, res => {
          this.$toast.open(res.body.message)
          this.loading = false
        })
      },
      buildMetas () {
        if (this.meta) {
//          var limite = this.meta.META + 1000
          this.dadosMetas = {
            labels: [''],
            datasets: [
              {
                label: 'Meta',
                backgroundColor: [
                  'rgba(128, 32, 0, 0.5)'
                ],
                borderColor: [
                  'rgba(128, 32, 0, 1)'
                ],
                borderWidth: 1,
                data: [this.meta.META]
              },
              {
                label: 'Faturado',
                backgroundColor: [
                  'rgba(102, 102, 102, 0.5)'
                ],
                borderColor: [
                  'rgba(102, 102, 102, 1)'
                ],
                borderWidth: 1,
                data: [this.meta.REALIZADO]
              },
              {
                label: 'À Realizar',
                backgroundColor: [
                  'rgba(90, 90, 20, 0.5)'
                ],
                borderColor: [
                  'rgba(90, 90, 20, 1)'
                ],
                borderWidth: 1,
                data: [this.meta.REALIZAR]
              }
            ]
          }
        }
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Grafico.vue